
export async function upnpNat () {
  throw new Error('Not supported in browsers')
}

export async function pmpNat () {
  throw new Error('Not supported in browsers')
}
